import React, { useMemo } from "react";
import "./BioEditor.scss";
import { Divider } from "primereact/divider";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

interface BioEditorProps {
  value: string;
  onChange: (value: string) => void;
}

export const BioEditor: React.FC<BioEditorProps> = ({ value, onChange }) => {
  const maxLength = 1000;

  // Calculate remaining characters (strip HTML tags for accurate count)
  const getTextLength = (html: string) => {
    const tmp = document.createElement("div");
    tmp.innerHTML = html;
    return tmp.textContent?.length || 0;
  };

  const remainingChars = maxLength - getTextLength(value);

  // Quill modules configuration
  const modules = useMemo(
    () => ({
      toolbar: {
        container: [
          ["bold", "italic", "underline", "strike"],
          [{ list: "ordered" }, { list: "bullet" }],
          [{ align: [] }],
          ["blockquote"],
          ["link", "image"],
          ["code-block"],
          ["clean"],
        ],
      },
    }),
    [],
  );

  const formats = [
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "bullet",
    "align",
    "blockquote",
    "link",
    "image",
    "code-block",
  ];

  const handleChange = (content: string) => {
    const textLength = getTextLength(content);
    if (textLength <= maxLength) {
      onChange(content);
    }
  };

  return (
    <>
      <div className="form-row">
        <div className="form-group">
          <label htmlFor="bio">
            Bio (optional)
            <p className="form-description">Write a short introduction.</p>
          </label>
          <div className="bio-editor">
            <ReactQuill
              theme="snow"
              value={value}
              onChange={handleChange}
              modules={modules}
              formats={formats}
              placeholder="Write a short bio..."
              className="custom-quill-editor"
            />
            <div className="char-count">{remainingChars} characters left</div>
          </div>
        </div>
      </div>
      <Divider />
    </>
  );
};
